import { EnvironmentTag } from '@dmp/shared/components';
import { PublicChangelogModal } from '@dmp/shared/public-changelog';
import 'focus-visible/dist/focus-visible';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import { AppProvider } from './app/app-provider';
import { publicChangelogConfig } from './app/public-changelog';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <AppProvider>
        <App />
        <EnvironmentTag />
        <PublicChangelogModal config={publicChangelogConfig} />
    </AppProvider>
);
